import { gsap } from 'gsap';
const navItems = document.querySelectorAll( '.js-nav-item' );

export function animateItemsIn() {
    const nav = document.querySelector('.nav');

    nav.style.display = 'block';
    nav.setAttribute('aria-hidden', 'false');
    nav.inert = false;

    gsap.set('.nav', {
        opacity: 0,
        visibility: 'visible',
    });

    gsap.to( '.nav', {
        duration: 0.2,
        opacity: 1,
        backgroundColor: '#D9F767',
        delay: 0.1,
        onComplete: () => {
            document.querySelector( '.nav' ).style.visibility = 'visible';
        }
    } );

    gsap.set( navItems, {
        opacity: 0,
        y: -20,
    } );

    gsap.to( navItems, {
        duration: 1,
        opacity: 1,
        y: 0,
        stagger: 0.1,
        delay: 0.5,
        ease: 'power2.out',
        onComplete: () => {
            document.querySelector( '.nav' ).style.visibility = 'visible';
        }
    } );
};

export function animateItemsOut() {
    gsap.to( navItems, {
        duration: 0.3,
        opacity: 0,
    } );

    gsap.to( '.nav', {
        duration: 0.3,
        opacity: 0,
        delay: 0.4,
        onComplete: () => {
            const nav = document.querySelector('.nav');
            nav.style.display = 'none';
            nav.setAttribute('aria-hidden', 'true');
            nav.inert = true;
        }
    } );
}